/* eslint-disable @nx/enforce-module-boundaries */
import { TagIconV2, VerticalThreeDot } from '@mybridge/icons';
import {
  Box,
  CloseButton,
  HStack,
  IconButton,
  Input,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
  Tooltip,
} from '@mybridge/ui';
import Giphy from '@mybridge/ui/giphy';
import { forwardRef, useContext, useEffect, useState } from 'react';
import { PostFormContext } from '../context';
import { PostFormFeelingsPicker } from '../feelings-picker';
import { PostFormTagPeople } from '../tag-people';
import { PostFormMoreOptionsMenu } from './menu';
import { ChevronLeftIcon } from '@chakra-ui/icons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDispatch, useSelector } from 'react-redux';
import { getFeelingsAndActivities } from 'v4/store/actions/global.data.actions';
export const PostFormMorePicker = forwardRef(({ children, fromProfilePhotoVideo, ...props }, ref) => {
  const {
    setGifs,
    images,
    videos,
    moreOptionsActiveTab,
    setMoreOptionsActiveTab,
    moreOptionsDisc,
    handleMediaFilesChange,
    fileInputRef,
    openMoreOptions,
    setOpenMoreOptions
  } = useContext(PostFormContext);
  const [query, setQuery] = useState('')
  const [searched, setSearched] = useState(false)
  
  
  const onSelect = (gif) => {

    setGifs?.([gif]);
    moreOptionsDisc?.onClose?.();
  };

  const { t } = useTranslator();
  const dispatch = useDispatch();
  const { loggedIn } = useSelector((state) => state.user);

  // const [openMoreOptions , setOpenMoreOptions] = useState(false);

  useEffect(()=>{
      if(!openMoreOptions){
        setMoreOptionsActiveTab(null);
        moreOptionsDisc?.onClose?.();
      }
      if(openMoreOptions){
         moreOptionsDisc?.onOpen?.();
         if (loggedIn) {
            dispatch(getFeelingsAndActivities());
         }
      }
  },[openMoreOptions])

  const handleSearch = (e) => {
    const value = e.target.value
    setQuery(value)
    setSearched(value.trim().length > 0) // switch to search if not empty
  }
  return (
    <>
      <Popover {...moreOptionsDisc}>
        <PopoverTrigger>
          <Box>
            <Tooltip
              label={fromProfilePhotoVideo ? 'Tag People' : ''}
              placement="top"
              hasArrow
              isDisabled={!fromProfilePhotoVideo}
            >
              <IconButton
                onClick={(e) => {
                  setOpenMoreOptions(true);
                  setMoreOptionsActiveTab(fromProfilePhotoVideo ? 'tag' : null);
                }}
                minW={fromProfilePhotoVideo ? '10' : '4'}
                p={1}
                borderRadius={fromProfilePhotoVideo ? '30px' : '8px'}
                padding="6px"
                _hover={fromProfilePhotoVideo? {background: '#3D5A80'} : null}
              >
                {fromProfilePhotoVideo ? (
                  <TagIconV2 width={20} height={20} />
                ) : (
                  <VerticalThreeDot width={20} height={20} />
                )}
              </IconButton>
            </Tooltip>
          </Box>
        </PopoverTrigger>
        <PopoverContent w="md">
          <PopoverBody p={4} w="100%">
            {moreOptionsActiveTab?.length && (
              <>
                {moreOptionsActiveTab === 'feeling' ? (
                  <>
                    <PostFormFeelingsPicker />
                  </>
                ) : (
                  ''
                )}
                {moreOptionsActiveTab === 'tag' ? (
                  <>
                    <PostFormTagPeople />
                  </>
                ) : (
                  ''
                )}
                {moreOptionsActiveTab === 'gif' ? (
                  <>
                    <HStack>
                      <IconButton
                        onClick={(e) => setMoreOptionsActiveTab(null)}
                        variant="ghost"
                      >
                        <ChevronLeftIcon />
                      </IconButton>
                      <HStack flex={1}>
                        <Text fontWeight="bold" color="brandPrimary.500">
                          {t('otherModules.choose_gif') || "Choose Gif"}
                        </Text>
                      </HStack>
                      <CloseButton onClick={(e) => {
                        setOpenMoreOptions(false)
                        setMoreOptionsActiveTab(null);
                      }} />
                    </HStack>
                    <Input
                             placeholder="Search for GIFs..."
                             value={query}
                             onChange={handleSearch}
                             mb={6}
                            //  maxW="400px"
                             />
                    <HStack justifyContent="center">
                   
                           <Giphy
                               searchQuery={query}
                               searched={searched}
                               onSelect={onSelect} 
                              //  onLoad={()=>handleGiphyLoaded()}
                             />
                    </HStack>
                  </>
                ) : (
                  ''
                )}
              </>
            )}
            {openMoreOptions && !moreOptionsActiveTab?.length && !fromProfilePhotoVideo &&
               ( <PostFormMoreOptionsMenu setOpenMoreOptions={setOpenMoreOptions} />)
            }
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </>
  );
});
